export const HERE_API = {
  APP_ID: '4i6DFMof3BCiqCiun3xm',
  APP_CODE: 'TSyvE5yaGmjkOo4LtaANVw'
}
